// Convert base64-encoded PCM16 (little-endian) to Float32 samples in [-1, 1].
// This is kept as a pure utility so it can be unit tested in Jest.
export default function pcm16Base64ToFloat32(base64Pcm) {
  if (typeof base64Pcm !== "string" || base64Pcm.length === 0) return new Float32Array(0);

  let bytes;
  if (typeof atob === "function") {
    const binary = atob(base64Pcm);
    bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  } else if (typeof Buffer !== "undefined") {
    bytes = new Uint8Array(Buffer.from(base64Pcm, "base64"));
  } else {
    // Fallback: cannot decode in this environment.
    return new Float32Array(0);
  }

  // PCM16 needs even byte length (2 bytes per sample).
  if (bytes.length % 2 !== 0) bytes = bytes.slice(0, bytes.length - 1);

  const pcm16 = new Int16Array(bytes.buffer);
  const float32 = new Float32Array(pcm16.length);

  for (let i = 0; i < pcm16.length; i++) {
    float32[i] = Math.max(-1, Math.min(1, pcm16[i] / 32768));
  }

  return float32;
}

